<ng-template #settingsTemplate>
    <app-tool-setting label="Formaat">
        <app-range-slider
            [min]="numLayersMin"
            [max]="numLayersMax"
            [(range)]="numLayers"
            label="Lagen"
        ></app-range-slider>
        <app-range-slider
            [min]="numCirclesMin"
            [max]="nnumCirclesMax"
            [(range)]="numCircles"
            label="bollen"
        ></app-range-slider>
    </app-tool-setting>
    <app-tool-setting label="Vul in" class="tool-setting-groups">
        <div class="tool-setting-group">
            <app-radio-input
                [value]="'add'"
                [model]="addOrSubstract"
                (selected)="setAddOrSubstract('add')"
                >optellen</app-radio-input
            >
            <app-radio-input
                [value]="'substract'"
                [model]="addOrSubstract"
                (selected)="setAddOrSubstract('substract')"
                >aftrekken</app-radio-input
            >
        </div>
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        style="pointer-events: none"
        [attr.viewBox]="
            332 -
            numCircles * 28 +
            ' 0 ' +
            numCircles * 29 +
            ' ' +
            (numLayers + 1) * 33
        "
        [ngStyle]="{
            'width.px': numCircles * 41 + 210,
            'height.px': (numLayers + 1) * 50
        }"
    >
        <defs>
            <style>
                .sf-1 {
                    fill: #0091d5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                }
                .sf-1,
                .sf-4,
                .sf-5 {
                    stroke: #0091d5;
                }
                .sf-2,
                .sf-5,
                .sf-9 {
                    fill: #fff;
                }
                .sf-2 {
                    stroke: #0090c9;
                }
                .sf-3 {
                    fill: #1d1d1b;
                }
                .sf-4 {
                    fill: #cce9f7;
                }
                .sf-6,
                .sf-7 {
                    fill: none;
                    stroke: #a1a1a1;
                }
                .sf-6 {
                    stroke-width: 0.91px;
                }
                .sf-7 {
                    stroke-width: 0.91px;
                }
                .sf-8,
                .sf-9 {
                    font-size: 18px;
                }
                .sf-8 {
                    font-family: UniversLTStd, Univers LT Std;
                }
                .sf-9 {
                    font-family: UniversLTStd, Univers LT Std;
                    font-weight: 700;
                }
                .sf-10 {
                    letter-spacing: -0.06em;
                }
                .circle-selected {
                    fill: rgb(204, 233, 247);
                }
            </style>
        </defs>

        <g class="head" style="pointer-events: all" (click)="setActiveField(0)">
            <polygon
                class="sf-1"
                points="398.42 37.5 327.92 0.5 257.42 37.5 398.42 37.5"
            />
            <text
                class="sf-9"
                text-anchor="middle"
                transform="translate(327 29)"
            >
                {{ values[0] }}
            </text>
            @if (activeField === 0) {
            <g>
                <line class="sf-7" x1="312" y1="33.5" x2="344" y2="33.5" />
            </g>
            }
        </g>

        @for (layers of [].constructor(numLayers); track $index; let index =
        $index) {
        <g class="rows">
            <g
                class="row"
                [ngStyle]="{transform: 'translateY(' + index * 31 + 'px)'}"
            >
                <g class="field_left">
                    <rect
                        style="
                            pointer-events: all;
                            stroke-dasharray: 70.5 31 101.5;
                        "
                        (click)="setActiveField(1 + 2 * index)"
                        class="sf-2"
                        x="257.42"
                        y="37.5"
                        width="70.5"
                        height="31"
                    />
                    <text
                        class="sf-8"
                        text-anchor="middle"
                        transform="translate(300 59.98)"
                    >
                        {{ values[1 + 2 * index] }}
                    </text>
                    @if (activeField === (1 + 2 * index)) {
                    <g>
                        <line
                            class="sf-7"
                            x1="284.1"
                            y1="63.5"
                            x2="316.1"
                            y2="63.5"
                        />
                    </g>
                    }
                </g>
                <g class="field_right">
                    <rect
                        style="pointer-events: all; stroke-dasharray: 172 31"
                        (click)="setActiveField(2 + 2 * index)"
                        class="sf-2"
                        x="327.92"
                        y="37.5"
                        width="70.5"
                        height="31"
                    />
                    <text
                        class="sf-8"
                        text-anchor="middle"
                        transform="translate(355 59.98)"
                    >
                        {{ values[2 + 2 * index] }}
                    </text>
                    @if (activeField === (2 + 2 * index)) {
                    <g>
                        <line
                            class="sf-6"
                            x1="341.04"
                            y1="63.5"
                            x2="373.04"
                            y2="63.5"
                        />
                    </g>
                    }
                </g>
                @if (addOrSubstract === 'substract') {
                <text
                    class="sf-8"
                    style="font-weight: bold"
                    text-anchor="middle"
                    transform="translate(327.5 59.98)"
                >
                    –
                </text>
                } @if (addOrSubstract === 'add') {
                <text
                    class="sf-8"
                    style="font-weight: bold"
                    text-anchor="middle"
                    transform="translate(327.5 59.98)"
                >
                    +
                </text>
                } @for (circle of [].constructor(numCircles); track $index; let
                index = $index) {
                <g class="circles">
                    <circle
                        style="pointer-events: all"
                        class="sf-5"
                        (click)="toggleCircle($event)"
                        [attr.cx]="238 - 25 * index"
                        cy="53"
                        r="9.5"
                    />
                </g>
                }
            </g>
        </g>
        }
    </svg>
</ng-template>
